'use strict'
var macrosites = angular.module('macrositesModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap',
	'ui.tinymce'	
]);
// require('./relatedNews/js/directive/macrositesRelatedNewsDirective.js')(macrosites);
// require('./relatedNews/js/macrositesRelatedNewsController.js')(macrosites);
require('./focusNews/js/directive/macrositesFocusNewsDirective.js')(macrosites);
require('./focusNews/js/macrositesFocusNewsController.js')(macrosites);


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/macrositesModule/macrositesModule.js
// module id = 512
// module chunks = 0